<template>
  <footer class="app-footer" :style="{ background: footerBackground }">
    <div class="footer-inner">
      <!-- 顶部：品牌列 + 4 个链接列（设计稿 5 列网格） -->
      <div class="footer-grid">
        <!-- 品牌列 -->
        <div class="footer-brand">
          <div class="brand">
             <img class="brand-logo" :src="footerMainLogo" />
            <span class="brand-name">Green Apple</span>
          </div>
          <p class="brand-desc">全球知识公地 —— 报纸、图书、期刊与视频，汇聚成一个世界的知识库。</p>
        </div>

        <!-- 链接列（资源 / 账户 / 产品 / 法律） -->
        <div v-for="col in columns" :key="col.title" class="footer-col">
          <h4 class="col-title">{{ col.title }}</h4>
          <el-link
            v-for="link in col.links"
            :key="link"
            class="footer-link"
            :underline="false"
            href="javascript:void(0)"
            >{{ link }}</el-link
          >
        </div>
      </div>

      <!-- 分隔线 -->
      <el-divider class="footer-divider"></el-divider>

      <!-- 底部版权行 -->
      <div class="footer-bottom">
        <span class="copyright">© 2026 Green Apple Knowledge, Inc. 保留所有权利。</span>
        <span class="built-for">面向全球市场构建</span>
      </div>
    </div>
  </footer>
</template>

<script>
import { getBranding } from '@/config/branding'
import logoSmall from '@/assets/image/common/logo_small.png'
export default {
  name: 'EastViewFooter',
  data() {
    return {
      columns: [
        { title: '资源', links: ['报纸', '图书', '期刊', '视频'] },
        // { title: '账户', links: ['登录', '我的订单', '购物车', '移动 App'] },
        { title: '产品', links: ['关于我们', '研究者空间', 'API 开放平台', '移动 App'] },
        { title: '法律', links: ['隐私政策', '服务条款', '版权声明', '合规'] }
      ]
    }
  },
  computed: {
    footerMainLogo() {
      const logo = getBranding().logos.footerMain
      if (logo) return logo
      return logoSmall
    },
    // 背景色按路由动态变化：/subject 页面使用浅灰背景，其余页面默认白色
    footerBackground() {
      return this.$route.path.includes('subject') ? '#F7F8FB' : '#ffffff'
    }
  }
}
</script>

<style scoped>
/* 设计稿页脚：白色通栏背景（Rectangle 4 = #ffffff），上 padding 64 */
.app-footer {
  background: #ffffff;
  padding: 64px 0 32px;
  font-family: 'Noto Sans SC', 'Inter', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1f2733;
}
/* 内容区：1360 宽居中，对应设计稿左右 280 留白（1920 - 1360）/ 2 */
.footer-inner {
  width: 100%;
  margin: 0 auto;
  padding: 0px 160px;
}
/* 5 列网格：品牌列 360 + 链接列 198×4 + 列间距 60，1:1 还原设计稿 itemSpacing=60 */
.footer-grid {
  display: flex;
  gap: 60px;
  align-items: flex-start;
}
.footer-brand {
  flex: 0 0 360px;
}
.footer-col {
  flex: 0 0 198px;
}
/* 品牌 */
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.brand-logo {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: linear-gradient(135deg, #34d399, #0d9f6e); /* 设计稿 Logo 渐变绿 */
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand-name {
  font-size: 18px;
  font-weight: 700;
  color: #111111;
  font-family: 'Inter', sans-serif;
}
.brand-desc {
  margin: 12px 0 0;
  max-width: 216px;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.65); /* 设计稿 65% 黑 */
}
/* 链接列 */
.col-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #111111;
}
.footer-link {
  display: block;
  margin-bottom: 10px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65) !important; /* 覆盖 el-link 默认色，匹配设计稿 65% 黑 */
}
.footer-link:hover {
  color: #0056d2 !important; /* 品牌主色 hover */
}
/* 分隔线：设计稿浅灰 #e4e4e7 */
.footer-divider {
  margin: 24px 0;
  background-color: #e4e4e7;
}
/* 底栏 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}

/* 响应式：窄屏不溢出，列自动换行 */
@media (max-width: 1440px) {
  .footer-inner {
    width: auto;
    padding: 0 160px;
  }
  .footer-grid {
    flex-wrap: wrap;
  }
}
</style>
